/**
 * @author: SuperHorse.马超 machao@meitunmama.com
 * Created on 2018/12/25.
 *
 */
// 专家义诊相关接口
export default {
  getIndexInfo: '/mapi/dayima-zjyz-banner/queryActivityInfo', // 专家义诊首页信息获取
  getFreeClinicExpert: '/mapi/dayima-zjyz-banner/queryExpertInfo',   // 义诊专家查询
  getVoteRankInfo: '/mapi/dayima-zjyz-banner/queryQuestionVoteRankingInfo', // 获取投票排行信息
  getUserActivityInfo: '/mapi/dayima-zjyz-banner/queryUserActivityInfo',
  canFreeAuditQues: '/mapi/dayima-questions/canFreeAuditQues', // 获取免费旁听问题列表
  questionSubmit: '/mapi/dayima-zjyz-question/voluntaryQuestionSubmit', // 专家义诊用户提问接口
  getConsultDetail: '/mapi/dayima-zjyz-question/voluntaryQuestionDetailInfo',   // 获取问题详情
  vote: '/mapi/dayima-zjyz-vote/questionVote', // 投票接口
  // vote: '/mapi/dayima-zjyz-banner/questionVote',  // 投票接口
  myConsultList: '/mapi/dayima-user/myQuestionList',  // 我的提问列表
  getBaseInfo: '/mapi/dayima-expert/getBaseInfo', // 专家义诊问题描述页获取对应专家信息
  babayTreeUploadImg: '/mobile/up/img', // 宝宝树上传图片
  babayTreeUploadImgbase64: '/mobile/up/base64/img', // 宝宝树上传图片 base64
  getUserLoginStr: '/newapi/router/user/getUserLoginStr' // 根据宝宝树用户id生成loginStr
}
;



// WEBPACK FOOTER //
// ./src/comm/api/freeClinic/index.js